import React from 'react'
import { Heading } from '@myxplor/ui'

import { BookingScheduleForCWA } from '../../care-enrolments/details/ccs-gov-enrolments'
import { name } from './helpers'

import './styles.css'

const EnrolmentSchedules = ({ week1 = [], week2 = undefined, child, service }) => (
  <div className="formSection">
    <Heading small compact>
      Routine Sessions
    </Heading>
    <p>
      The routine sessions of care that will be provided to {name(child)} by {name(service)} are
      outlined below. This includes the usual start and end times for these sessions of care and the
      daily rates. While casual sessions are not displayed, you are still able to book these by
      contacting your child care provider or by using Xplor Mobile Bookings.
    </p>
    {week1.length === 0 &&
      (week2 === undefined || week2.length === 0) && (
        <Heading small>There are no routine sessions</Heading>
      )}
    {(week1.length !== 0 || week2) && (
      <p>
        Your care is provided on a <strong>{week2 ? 'fortnightly' : 'weekly'}</strong> schedule:
      </p>
    )}
    {(week1.length !== 0 || week2) && <BookingScheduleForCWA week1={week1} week2={week2} />}
  </div>
)

export default EnrolmentSchedules



// WEBPACK FOOTER //
// ./src/parent-agreement/views/enrolment-schedules.jsx